'use strict';

angular.module('user')
    .component('userProfileDataForm', {
        templateUrl: 'js/modules/user/components/profile-data-form/template.html',
        controller: 'UserProfileDataFormController',
    });
